import { ReactNode } from 'react';
import { SxProps, TableRowProps } from '@mui/material';

import { TableCell } from './TableCell';
import { TableRow } from './Table';

import { IconButton } from '../IconButton';
import { KeyboardArrowDownIcon, KeyboardArrowUpIcon } from '../../icons';

type ExpandableTableRowProps = TableRowProps & {
  children: ReactNode;
  expandedContent: ReactNode;
  isExpanded: boolean;
  onClick: () => void;
  arrowCellSx?: SxProps;
};

export const ExpandableTableRow = ({
  children,
  expandedContent,
  isExpanded,
  onClick,
  arrowCellSx,
  ...otherProps
}: ExpandableTableRowProps) => {
  return (
    <>
      <TableRow sx={{ cursor: 'pointer', userSelect: 'none' }} onClick={onClick} {...otherProps}>
        <TableCell padding='checkbox' sx={arrowCellSx}>
          <IconButton>
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {children}
      </TableRow>
      {isExpanded && <TableRow hover={false}>{expandedContent}</TableRow>}
    </>
  );
};
